import React, { useEffect } from "react";
import { motion } from "framer-motion";
import FullWidthLayout from "hocs/layouts/FullWidthLayout";

const GetStartedPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <FullWidthLayout>
    <div className=" bg-white text-gray-900">
      {/* Contenedor Principal */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="max-w-5xl mx-auto px-6 py-16 text-center"
      >
        {/* Título */}
        <motion.h1
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          className="text-5xl font-bold text-gray-900"
        >
          Schedule A Call With Us
        </motion.h1>

        {/* Descripción */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut", delay: 0.2 }}
          className="mt-6 text-lg text-gray-600 leading-relaxed"
        >
          In this personalized call, we’ll take the time to understand you, your business, 
          and your unique staffing needs. Drawing on our experience working with hundreds 
          of attorneys, we’ll help you pinpoint the key areas where hiring could make the 
          biggest impact, and introduce you to the ways your virtual office can help you meet those needs. 
          Our goal is for you to leave this session with a clear understanding of your hiring 
          priorities and actionable insights to move forward with confidence.
        </motion.p>
      </motion.div>

      {/* Sección Calendly */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, ease: "easeOut", delay: 0.4 }}
        className="max-w-5xl mx-auto px-6 pb-16"
      >
        <div className="border rounded-lg shadow-lg overflow-hidden">
        
        </div>
      </motion.div>
    </div>
    </FullWidthLayout>
  );
};

export default GetStartedPage;
